import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/bthinking/bthinking/src/components/mdx/MDXPageLayout";
import { withPrefix } from 'gatsby';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "introducao-ao-b_thinking",
      "style": {
        "position": "relative"
      }
    }}>{`Introdução ao B_thinking`}</h1>
    <p>{`O `}<strong parentName="p">{`B_thinking`}</strong>{` é um modelo de processo que auxilia os bridgers a criarem produtos incríveis de forma colaborativa. Ele é composto por princípios, etapas e métodos que servem como um guia para o trabalho dos nossos times de `}<strong parentName="p">{`design`}</strong>{`, `}<strong parentName="p">{`produto`}</strong>{` e `}<strong parentName="p">{`desenvolvimento`}</strong>{`.`}</p>
    <p>{`Os `}<a parentName="p" {...{
        "href": "/principles"
      }}>{`princípios`}</a>{` englobam nossa forma de agir como time e organização, as `}<a parentName="p" {...{
        "href": "/steps/flowchart"
      }}>{`etapas`}</a>{` auxiliam a encaixar as demandas dentro do processo de
descoberta ou entrega e os `}<a href="/methods/briefing/">{` métodos `}</a>{` fornecem técnicas para melhor desempenhar as atividades.`}</p>
    <p style={{
      "textAlign": "center"
    }}><img src={withPrefix("/image/bthinking_introducao.png")} width="652.8" height="453.56" alt="Introduzindo o bthinking" /></p> 
    <h2 {...{
      "id": "processo-melhor--produto-ainda-melhor",
      "style": {
        "position": "relative"
      }
    }}>{`Processo melhor = produto ainda melhor!`}</h2>
    <p>{`O B_thinking oferece uma visão descritiva de como explorar problemas complexos voltados para a criação de software. Ele norteia o processo de criação dos produtos, auxiliando a:`}</p>
    <ul>
      <li parentName="ul">{`Encontrar a definição e o escopo de problemas complexos;`}</li>
      <li parentName="ul">{`Criar hipóteses para resolução do problema identificado;`}</li>
      <li parentName="ul">{`Desenvolver protótipos e validá-los, pautando assim as escolhas em dados empíricos;`}</li>
      <li parentName="ul">{`Transicionar entre as etapas de descoberta e entrega, delimitando o problema e refinando-o com o time de desenvolvimento;`}</li>
      <li parentName="ul">{`Entregar as funcionalidades, trazendo o time para o centro das principais decisões;`}</li>
      <li parentName="ul">{`Avaliar as entregas para descobrir quais melhorias ainda precisam ser realizadas no sistema.`}</li>
    </ul>
    <p>{`Assim, criamos produtos que geram valor aos usuários e satisfazem a todos os stakeholders envolvidos :)`}</p>
    <h2 {...{
      "id": "maturidade-em-ux",
      "style": {
        "position": "relative"
      }
    }}>{`Maturidade em UX`}</h2>
    <p>{`O B_thinking foi construído com o objetivo de amadurecer o processo de UX do Bridge. Por isso, além de servir como modelo de processo ele
é utilizado como uma ferramenta para aumentar o conhecimento de toda a equipe sobre UX. O B_thinking:`}</p>
    <ul>
      <li parentName="ul">{`Facilita o onboarding de novos bridgers;`}</li>
      <li parentName="ul">{`Traz clareza para toda a equipe sobre o processo de criação dos produtos;`}</li>
      <li parentName="ul">{`Facilita a comunicação sobre as atividades realizadas;`}</li>
      <li parentName="ul">{`Cria uma base de conceitual comum entre bridgers e clientes;`}</li>
      <li parentName="ul">{`Facilita a troca de conhecimento sobre o processo de UX;`}</li>
      <li parentName="ul">{`Resulta no amadurecimento das nossas equipes.`}</li>
    </ul>
    <hr></hr>
    <p>{`O B_thinking está sendo evoluído contínuamente, conforme nossos times de produto experimentam novos métodos.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      